<template lang="pug">
v-card.round-xl(min-height="350" flat)
  .font-semibold.text-lg.pa-6 {{ title }}
  v-divider
  .py-4
    div(v-if="loading")
      v-skeleton-loader.mx-4(type="list-item-three-line@2")
    v-card(flat v-else)
      apexchart(type="donut" width="100%" :options="chartOptions" :series="series")
      v-overlay.primary--text.text-center(v-if="isEmptyChartData" absolute color="white" opacity="0.9" z-index="2")
        v-icon.mb-2(color="primary" size=20) $yzi-bar-chart-10
        .h8.mb-1 No data available
        .text-sm There’s no data available yet for this chart
</template>

<script>
export default {
  name: 'PieChartCard',
  props: {
    title: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: null
    },
    type: {
      type: String
    }
  },
  data: () => ({
  }),
  computed: {
    series () {
      return this.data?.values || []
    },
    isEmptyChartData () {
      return this.data?.values?.every(item => item === 0)
    },
    colors () {
      switch (this.type) {
        case 'inclinic':
          return ['#00A699', '#62C3B7']
        case 'appointments':
          return ['#e91e63', '#fc91a4']
        default:
          return this.series.length === 2 ? ['#5856d6', '#cfc4f5'] : ['#5856d6', '#8579e1', '#ac9eeb', '#cfc4f5', '#f0ebff']
      }
    },
    chartOptions () { 
      return {
        dataLabels: {
          enabled: true
        },
        colors: this.colors,
        chart: {
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false
          },
        },
        stroke: {
          width: 0
        },
        xaxis: {
          labels: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        grid: {
          show: false
        },
        labels: this.data?.labels || []
      }
    }
  }
}
</script>